module.exports = __webpack_public_path__ + "img/ear-listen.718ba1c9.svg";